
<template>
  <div >
    <div v-if="telaInicial" class="d-flex h-100 w-100">
       <div class="col-md-3 altura-card-kambam" id="first-col">
          <searchocurrence ref="searchocurrence" :flchangeMinizado="flchangeMinizado" @changeMinizado="changeMinizado" @search="search"></searchocurrence>
       </div>
       <div class="col-md-9" id="second-col">
          <div id="button-group-grid" >
              <groupbuttonocurrence @changeKanban="changeKanban"></groupbuttonocurrence>
            </div>
          <div v-if="!kanbanOn" >
            <tableocurrence @Details="edit" ref="tableocurrence">
            </tableocurrence>
          </div>
          <div class="altura-card-kambam" v-else>
            <KabanOcorrence :dataSearchDetails="dataSearchDetails" ref="KabanOcorrence" @detalhe="edit"></KabanOcorrence>
          </div>
        </div>
           <addocurrence v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)"
                @reload="reload"
                class="container-add-button-ocurrence"></addocurrence>
    </div>

    <div v-if="!telaInicial">
      <sorting :dataDetails="dataDetails"></sorting>
    </div>
    </div>

</template>
<script>
import Ocurrence from '@/views/private/realestate/ocurrence/ocurrence.js'
export default Ocurrence
</script>
<style scoped>
:deep(.card) {
    margin-bottom: 1.5rem;
    height: 100%;
}

/* .altura-card-kambam {
} */

#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;
}

.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

#button-group-grid{
  position: absolute;
  z-index: 10;
  right: 30px;
  top: 8px;
  color: white;
}

.acording{
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  background-color: #ECEFF1;
  border-radius: 0px;
  height: 50px;
  width: 100%;
}
.mes{
  font-size: 22px;
  color: black;
  padding-top: 16px;
  font-weight: bold;
}

.footer{
  margin-bottom: 10%;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

#card-sales{
  height: 100%;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#img-card{
  height: 300px;
  width: 300px;
  object-fit: contain;
}

.btnAdicionarComunicado{
  background-color: #008148;
  bottom: 56px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  font-size: 26px;
  position: fixed;
}

.container-add-button-ocurrence{
    position: fixed;
    bottom: calc(70px - 1vh);
    right: 10px;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/ocurrence.vue